module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.27927",
      "ably": "static-2.2",
      "ably-hubspot-js": "static-2.4370",
      "atom": "static-1.4742",
      "conversations-async-data": "static-2.7331",
      "conversations-error-reporting": "static-1.8546",
      "conversations-internal-pub-sub": "static-1.15633",
      "conversations-internal-schema": "static-1.12296",
      "conversations-message-history": "static-1.11623",
      "conversations-test-sdk": "static-1.10167",
      "conversations-visitor-experience-components": "static-1.21290",
      "head-dlb": "static-1.4702",
      "hs-promise-utils": "static-1.5259",
      "hs-test-utils": "static-1.7652",
      "hubspot-dlb": "static-2.1773",
      "HubStyleTokens": "static-2.11087",
      "I18n": "static-7.1535",
      "immer": "static-1.33",
      "jasmine-immutable": "static-1.2679",
      "jasmine-runner": "static-1.6122",
      "quartz": "static-1.6536",
      "react-dlb": "static-1.68",
      "react-select-plus": "static-1.65",
      "react-transition-group": "static-2.58",
      "redux-thunk": "static-2.43",
      "sanitize": "static-1.4145",
      "StyleGuideUI": "static-3.481",
      "transmute": "static-2.77",
      "urlinator": "static-1.4193",
      "usage-tracker": "static-1.7004",
      "usage-tracker-core": "static-1.6854",
      "usage-tracker-public": "static-1.6815",
      "viral-links-lib": "static-1.6682",
      "visitor-ui-component-library": "static-1.5794",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4446",
      "conversations-prop-types": "static-1.7116",
      "conversations-visitor-message-history": "static-1.20027",
      "cssUtils": "static-1.690",
      "enviro": "static-4.371",
      "flux-actions": "static-1.294",
      "foundations-components": "static-1.7230",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.5872",
      "hubspot-url-utils": "static-1.3825",
      "immutable": "static-2.19",
      "metrics-js": "static-1.9296",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.334",
      "raven": "static-3.5564",
      "react": "static-7.174",
      "react-aria": "static-1.59",
      "react-dom": "static-7.85",
      "react-redux": "static-7.65",
      "react-rhumb": "static-1.16294",
      "react-utils": "static-2.5056",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize-text": "static-1.7809",
      "signup-constants": "static-1.18114",
      "styled-components": "static-2.83",
      "usage-tracker-multi": "static-1.5418",
      "visitor-ui-component-library-icons": "static-1.5605",
      "hs-promise-rejection-tracking": "static-1.5234",
      "raven-hubspot": "static-1.5871",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.3104",
      "moment": "static-3.26",
      "quartz-config": "static-1.314",
      "quartz-core": "static-1.5755",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4499",
      "foundations-theming": "static-1.4070",
      "UIComponents": "static-3.8034",
      "cv-backend-services": "static-1.1432",
      "immutable-less": "static-1.4319",
      "conversations-skeleton-state": "static-1.6921",
      "crm-events-viz-core": "static-1.31985",
      "customer-agent-discovery-components-lib": "static-1.2089",
      "customer-data-objects": "static-1.7279",
      "data-fetching-client": "static-1.9343",
      "icons": "static-2.607",
      "react-input-autosize": "static-2.17",
      "react-router-dom": "static-5.26",
      "rpc-client-utils": "static-1.4272",
      "tanstack-virtual": "static-1.23",
      "ui-images": "static-2.1050",
      "HeadJS": "static-2.685",
      "framer-motion": "static-1.62",
      "hs-test-utils-bend-plugin": "static-1.2763",
      "msw": "static-1.39",
      "testing-library": "static-1.145",
      "i18n-data": "static-1.214",
      "moment-timezone": "static-5.76",
      "jasmine": "static-4.4003",
      "history": "static-4.47",
      "signup-ui-url-generator": "static-2.7711",
      "HubStyle": "static-2.11395",
      "quartz-i18n": "static-1.211",
      "sassPrefix": "static-1.149",
      "bend-plugin-foundations-components": "static-1.3499",
      "floating-ui": "static-1.49",
      "foundations-theming-specialty": "static-1.1786",
      "hs-story-utils": "static-1.9099",
      "react-virtualized": "static-2.92",
      "tanstack-table": "static-1.48",
      "trellis-assets": "static-1.921",
      "ui-fonts": "static-1.349",
      "csstype": "static-1.50",
      "quick-fetch": "static-1.3606",
      "usage-tracker-anonymous": "static-1.5421",
      "bender-build-tools": "static-1.2770",
      "dispatcher": "static-1.129",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.765",
      "hubspotter-http": "static-1.4356",
      "mobile-manifest-mixins": "static-1.458",
      "quartz-auth": "static-1.211",
      "quartz-head": "static-1.201",
      "quartz-test": "static-1.211",
      "bend-plugin-foundations-theming": "static-1.2553",
      "foundations-theming-base": "static-1.3055",
      "stylex": "static-1.25",
      "ts-schema": "static-1.3782",
      "apollo-stack-hubspot": "static-3.79",
      "avatar-components": "static-1.2129",
      "content-assistance-lib": "static-1.7256",
      "crm-component-utils": "static-1.38123",
      "crm-display-components": "static-1.23873",
      "crm-fe-perf": "static-1.22546",
      "crm-links": "static-1.5912",
      "crm-message-bus": "static-1.41980",
      "crm-search-service-types": "static-1.831",
      "crm-source-interpretation-lib": "static-1.5000",
      "customer-data-communicator": "static-1.44527",
      "customer-data-email": "static-1.17458",
      "customer-data-filters-ui": "static-1.38408",
      "customer-data-objects-ui-components": "static-1.12668",
      "customer-data-properties": "static-1.50382",
      "customer-data-rte": "static-1.32160",
      "customer-data-ui-utilities": "static-1.9492",
      "draft-plugins": "static-2.21079",
      "file-manager-components": "static-1.22498",
      "FileManagerCore": "static-1.37997",
      "framework-data-schema-resolvers": "static-1.6533",
      "frontend-preferences-client": "static-1.7591",
      "hubspot-apollo-client": "static-1.4549",
      "hubspot-prosemirror": "static-1.17248",
      "object-comments-thread-lib": "static-1.9764",
      "reference-resolvers-lite": "static-1.7759",
      "ui-addon-upgrades": "static-9.17370",
      "universal-associations-select": "static-1.10626",
      "ai-components-ui-library": "static-1.7999",
      "final-form": "static-1.63",
      "inbound-db-properties-service-client": "static-1.3555",
      "property-translator": "static-1.5083",
      "fast-json-stable-stringify": "static-1.4",
      "graphql": "static-1.75",
      "hub-http-shared-msw-handlers": "static-1.9137",
      "hubspotter-http-shared-msw-handlers": "static-1.9135",
      "superstore": "static-1.4437",
      "ui-addon-video-player": "static-1.8390",
      "ui-coaching-tips": "static-1.27570",
      "card-properties-lib": "static-1.43149",
      "crm-actions": "static-1.5939",
      "crm-cards-data": "static-1.1009",
      "crm-cards-sdk": "static-1.42504",
      "customer-data-properties-shared-msw-handlers": "static-1.8464",
      "customer-data-property-utils": "static-1.7732",
      "customer-data-tracking": "static-1.6530",
      "usage-tracker-container": "static-1.6994",
      "framework-data-table": "static-2.11114",
      "location-customization-utils-lib": "static-1.8129",
      "calling-error-reporting": "static-1.30962",
      "calling-internal-common": "static-1.30956",
      "calling-usage-tracker": "static-1.6208",
      "crm_data": "static-4.90796",
      "crm_schema": "static-3.90835",
      "crm-legacy-global-containers": "static-1.23557",
      "customer-data-content": "static-1.26610",
      "draft-content-plugins": "static-1.27426",
      "draft-convert": "static-2.31",
      "draft-email-branding-plugin": "static-2.23421",
      "draft-extend": "static-2.46",
      "draft-js": "static-5.37",
      "draft-signature-plugin": "static-1.23232",
      "EmailSignatureEditor": "static-1.23683",
      "FileManagerLib": "static-1.38138",
      "hubspot-prosemirror-plugins": "static-1.17240",
      "integration-settings-components": "static-1.14374",
      "integrations-lib": "static-1.14990",
      "integrations-tracking-lib": "static-1.5252",
      "native-integrations-shared-strings": "static-1.7456",
      "nav-meta": "static-1.28522",
      "onboarding-scopes": "static-1.6110",
      "outreach-assistant-email-generation": "static-1.5539",
      "prosemirror": "static-1.13",
      "quotes-client-types": "static-1.36783",
      "react-colorpicker": "static-2.9882",
      "react-dnd-compat": "static-1.4293",
      "react-immutable-render-mixin": "static-1.9",
      "reference-resolvers": "static-1.7828",
      "rich-text-lib": "static-1.19240",
      "sales-email-signature-service-client": "static-1.3507",
      "sequences-lib": "static-1.7485",
      "timezone-utils": "static-2.4913",
      "ui-addon-i18n": "static-1.10794",
      "ui-addon-iframeable": "static-1.8674",
      "ui-business-units-lib": "static-1.8677",
      "ui-gdpr-components": "static-1.10014",
      "ui-shepherd-react": "static-3.9808",
      "user-context": "static-1.4756",
      "whatsapp-sending-lib": "static-1.4518",
      "apollo-dlb": "static-3.80",
      "apollo-link-hub-http": "static-2.4317",
      "salesImages": "static-1.518",
      "customer-data-filters-ui-msw-helpers": "static-1.20842",
      "customer-data-reference-ui-components": "static-1.12793",
      "FormUrlGenerator": "static-2.4401",
      "framework-builder-read-service-client": "static-1.3724",
      "framework-data-schema-quick-fetch": "static-1.6438",
      "inbound-db-meta-service-client": "static-1.3337",
      "lodash": "static-4.7",
      "multi-account-reference-resolvers": "static-1.632",
      "onboarding-tours": "static-1.16081",
      "reporting-datasets-permissions-lib": "static-1.12614",
      "SharedI18nStrings": "static-1.179",
      "ui-addon-teams": "static-1.21038",
      "calling-global-api": "static-1.63196",
      "calling-lifecycle-internal": "static-1.64578",
      "calling-lifecycle-messages": "static-1.56872",
      "commerce-products-lib": "static-1.8445",
      "conditional-properties-service-client": "static-1.3499",
      "external-options-client-types": "static-1.3860",
      "google-libphonenumber": "static-1.31",
      "hs-entities": "static-1.317",
      "inbounddb-objects-service-types": "static-1.3928",
      "meetings-icalendar-utils-lib": "static-1.303",
      "multi-currency-client-types": "static-1.3399",
      "object-builder-ui-client": "static-1.47527",
      "pipeline-validation-client-types": "static-1.3663",
      "property-value-citations": "static-1.996",
      "pulse": "static-1.151",
      "smart-property-lib": "static-1.5394",
      "tiered-pricing": "static-1.618",
      "ui-addon-form-validation": "static-1.10665",
      "immerable": "static-1.3824",
      "video-components-external": "static-1.10157",
      "video-data-lib": "static-1.33815",
      "audio-components": "static-1.5424",
      "cropperjs": "static-1.10",
      "FileManagerImages": "static-1.35649",
      "ui-universal-auth": "static-1.8506",
      "video-components": "static-1.12160",
      "video-embed": "static-1.34649",
      "batch-promise": "static-1.1196",
      "crm-pipelines-api-client-types": "static-1.3843",
      "persist-promise": "static-1.3353",
      "hubspot-apollo-cache": "static-1.8",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.24345",
      "knowledge-content-types": "static-1.8266",
      "payment-link-components": "static-1.22570",
      "ui-addon-emoji-picker": "static-1.9559",
      "call-summary": "static-1.37887",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.9283",
      "feature-store-service-types": "static-1.4198",
      "merchandise-lib": "static-1.253",
      "purchase-motions-components": "static-1.5285",
      "self-service-api": "static-1.9894",
      "upgrade-management-service-types": "static-1.4189",
      "chatspot-core": "static-1.19806",
      "ContentUtils": "static-1.67190",
      "copilot-toolkit": "static-1.10193",
      "growth-onboarding-feedback-components": "static-1.6256",
      "customer-data-sidebar": "static-2.45071",
      "enrichment-properties-lib": "static-1.14512",
      "customer-data-associations": "static-1.7005",
      "deal-intel-decorators": "static-1.831",
      "reporting-data": "static-1.65935",
      "ui-addon-draggable": "static-3.4413",
      "crm-record-cards-service-types": "static-1.3336",
      "crm_universal": "static-1.21454",
      "SalesContentIndexUI": "static-3.8700",
      "signup-ui-lego-core": "static-1.20124",
      "content-embed-lib": "static-1.7005",
      "data-model-builder-lib": "static-1.11225",
      "remote-ui": "static-1.58",
      "ui-components-test-utils": "static-1.5225",
      "ui-extensions-remote-renderer": "static-1.16069",
      "universal-page-editor-lib": "static-1.2666",
      "integrations-error-boundary-lib": "static-1.12405",
      "laboratory-lib": "static-3.6808",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10043",
      "rxjs": "static-5.10",
      "messaging-types-lib": "static-1.44965",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "data-token-picker": "static-1.15830",
      "sequences-client-types-lib": "static-1.7342",
      "foundations-components-test-utils": "static-1.4713",
      "magpie-lib": "static-1.5242",
      "navigation-messaging": "static-1.6212",
      "getting-started-shared-tasks": "static-1.17483",
      "getting-started-shared-tasks-store": "static-1.16601",
      "onboarding-tours-utils": "static-1.147",
      "whatsapp-management-lib": "static-1.7677",
      "growth-data-modal": "static-1.4998",
      "growth-onboarding-confetti": "static-1.2721",
      "growth-onboarding-next-action-utils": "static-1.1157",
      "navigation-components": "static-1.16885",
      "onboarding-tours-client": "static-1.4295",
      "ui-shepherd-tracker": "static-1.7189",
      "shared-worker-versioning": "static-1.10686",
      "calling-orchestration-shared-library": "static-1.34385",
      "products-iframe-lib": "static-1.6998",
      "products-ui-components-shared-msw-handlers": "static-1.9519",
      "directed-graph": "static-1.603",
      "event-emitter": "static-1.595",
      "breeze-intelligence-kit": "static-1.5128",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9220",
      "fsm": "static-1.3399",
      "policy-lib": "static-1.6470",
      "react-tinymce": "static-1.54252",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.53378",
      "tinymce-plugins": "static-1.56492",
      "tinymce-themes": "static-1.55348",
      "content-media-composition-data-lib": "static-1.10877",
      "content-media-compositions": "static-2.14884",
      "idb-keyval": "static-1.37",
      "magpie-types": "static-1.4702",
      "media-bridge-lib": "static-1.18356",
      "content-icons-ui": "static-1.2106",
      "social-insights-client-types": "static-1.21040",
      "outpost": "static-1.3884",
      "commerce-analytics-service-client": "static-1.3351",
      "ui-addon-opt": "static-4.8058",
      "commerce-tours-lib": "static-1.5513",
      "growth-onboarding-reliability": "static-1.4758",
      "sales-checkout-service-client": "static-1.3363",
      "ai-addon-copilot-preview": "static-1.7211",
      "calling-cross-tab-library": "static-1.18923",
      "calling-lifecycle-usage-tracker": "static-1.7807",
      "wootric-nps": "static-1.6605",
      "growth-monetization-service-types": "static-1.4205",
      "nav-client-types": "static-1.2001",
      "purchase-motions-api": "static-1.5288",
      "trials-service-types": "static-1.3606",
      "chatspot-client-types": "static-1.10310",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4471",
      "underscore": "static-1.8",
      "simple-logging-lib": "static-1.2720",
      "card-payment-highlight-lib": "static-1.36142",
      "card-subscription-highlight-lib": "static-1.38565",
      "commerce-billing-lib": "static-1.18119",
      "commerce-contract-lib": "static-1.10669",
      "crm_components": "static-3.90796",
      "invoices-highlight-card-lib": "static-1.53574",
      "orders-highlight-card-lib": "static-1.20556",
      "products-highlight-card-lib": "static-1.16729",
      "project-storage": "static-1.4403",
      "quotes-highlight-card-lib": "static-1.70696",
      "usage-based-billing-components-lib": "static-1.7670",
      "deal-intel-utils": "static-1.835",
      "reporting-client-types": "static-1.2345",
      "react-flip-move": "static-1.63",
      "FireAlarmUi": "static-1.4204",
      "sales-templates-service-types-lib": "static-1.3872",
      "ui-asset-management-lib": "static-1.10513",
      "emoji-regex": "static-1.7",
      "association-settings-lib": "static-1.9261",
      "collaboration-sidebar": "static-1.56779",
      "conditional-property-settings-modal": "static-1.11666",
      "data-model-commons-lib": "static-1.11594",
      "feedback-loader": "static-1.28624",
      "html-to-image": "static-1.47",
      "object-definition-builder-lib": "static-1.6721",
      "property-management-iframe": "static-1.11800",
      "property-usages-lib": "static-1.5053",
      "reactflow": "static-1.57",
      "simple-data-table": "static-1.1829",
      "used-in-list-lib": "static-1.6576",
      "visual-association": "static-1.5505",
      "highcharts": "static-8.97",
      "reporting-visualizations": "static-1.58012",
      "ui-extensibility-client-types": "static-1.3622",
      "automation-platform-service-types": "static-1.2430",
      "ContentData": "static-1.67265",
      "email-portal-health-service-types": "static-1.645",
      "marketing-email-service-types": "static-1.1737",
      "reactive-lib": "static-1.395",
      "content-whatsapp-service-types": "static-1.176",
      "marketing-platform-lib": "static-1.6498",
      "short-messages-app-service-client": "static-1.3678",
      "ui-tool-access": "static-1.9804",
      "calling-orchestration-schema": "static-1.34610",
      "sales-views-client-types": "static-1.3961",
      "trellis-story-utils": "static-1.4193",
      "storybook-react": "static-1.26",
      "hub-http-contrib": "static-1.2717",
      "interframe": "static-3.4457",
      "tinymce-data": "static-1.39463",
      "ui-addon-sales-email": "static-1.4883",
      "codemirror": "static-5.88",
      "layout-dnd-components": "static-1.11803",
      "layout-dnd-utils": "static-1.10778",
      "react-codemirror": "static-1.10271",
      "ui-brand-identity-lib": "static-1.13328",
      "NamespacedHubStyle": "static-2.8779",
      "hls.js": "static-1.32",
      "js-cookie": "static-1.18",
      "ai-rendering-library": "static-1.8882",
      "ai-settings-ui-library": "static-1.7137",
      "chirp-fetch": "static-1.1551",
      "copilot-plugins": "static-1.10166",
      "eligibility-engine-service-types": "static-1.2887",
      "commerce-shared-components-lib": "static-1.17545",
      "commerce-subscription-lib": "static-1.36142",
      "commerce-tools-ui-lib": "static-1.9480",
      "usage-tracker-session-replay": "static-1.4690",
      "utility-belt": "static-1.2211",
      "payments-enrollment-embed-lib": "static-1.21492",
      "quotes-ui-lib": "static-1.79414",
      "zustand": "static-1.51",
      "accounting-integrations-ui-components": "static-1.6499",
      "invoices-ui-lib": "static-1.53590",
      "commerce-products-api": "static-1.1754",
      "SafeStorage": "static-1.4069",
      "invoices-iframe-lib": "static-1.55648",
      "quotes-modal-lib": "static-1.101371",
      "reporting-ui-components": "static-2.63208",
      "subscription-experience-data-types": "static-1.14397",
      "association-translator": "static-1.2862",
      "crm-settings-header-lib": "static-1.7970",
      "settings-ui-nav": "static-2.9814",
      "chatspot-widget-iframe": "static-1.19798",
      "collaboration-sidebar-common": "static-1.1576",
      "crm-properties-common-lib": "static-1.5538",
      "ui-addon-draggable-compat": "static-2.3923",
      "property-management-common": "static-1.4087",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.14606",
      "advanced-menus-lib": "static-1.11606",
      "ExportDialog": "static-6.10055",
      "ui-memberships-settings-lib": "static-1.33061",
      "diff-match-patch": "static-1.7",
      "layout-data-lib": "static-1.9103",
      "browser-eslint": "static-2.57",
      "embedded-academy-lib": "static-1.13137",
      "highlight.js": "static-1.72",
      "reporting-action-components": "static-1.40349",
      "ui-addon-react-router-dom": "static-1.9210",
      "growth-onboarding-empty-states": "static-1.5173",
      "InboxConnectUtils": "static-4.13876",
      "payments-post-enroll-local-storage-lib": "static-1.4758",
      "qrcode-generator": "static-1.62",
      "amplitude-session-replay-browser": "static-1.53",
      "marketplace-ui-apps-core": "static-1.17121",
      "stripe-embedded-components": "static-1.6911",
      "products-ui-components": "static-1.38964",
      "totals-ui-components": "static-1.22645",
      "reporting-plugins": "static-1.9800",
      "reporting-reports": "static-1.65614",
      "reporting-snowflake": "static-1.54554",
      "edison-service-client-types": "static-1.55",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.14605",
      "simple-menus-lib": "static-1.16122",
      "academy-common-lib": "static-1.12597",
      "dashboard-lib": "static-1.80100",
      "share-with-third-party-component-lib": "static-1.8355",
      "developer-experience-shared-components": "static-1.10095",
      "marketplace-ui-client-types": "static-1.15994",
      "marketplace-ui-common": "static-1.18587",
      "ui-addon-integrations-directory-panel": "static-2.7646",
      "stripe-connect-js": "static-1.61",
      "commerce-permissions": "static-1.416",
      "property-description-translator": "static-1.3529",
      "commerce-totals-service-types": "static-1.3519",
      "campaign-roi-lib": "static-1.7892",
      "academy-service-client": "static-1.3321",
      "redux-actions": "static-3.7",
      "apps-service-types": "static-1.3541",
      "oauth-service-types": "static-1.3910",
      "react-window": "static-1.13"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.27927",
      "ably": "/ably/static-2.2",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.4370",
      "atom": "/atom/static-1.4742",
      "conversations-async-data": "/conversations-async-data/static-2.7331",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8546",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15633",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12296",
      "conversations-message-history": "/conversations-message-history/static-1.11623",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.10167",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.21290",
      "head-dlb": "/head-dlb/static-1.4702",
      "hs-promise-utils": "/hs-promise-utils/static-1.5259",
      "hs-test-utils": "/hs-test-utils/static-1.7652",
      "hubspot-dlb": "/hubspot-dlb/static-2.1773",
      "HubStyleTokens": "/HubStyleTokens/static-2.11087",
      "I18n": "/I18n/static-7.1535",
      "immer": "/immer/static-1.33",
      "jasmine-immutable": "/jasmine-immutable/static-1.2679",
      "jasmine-runner": "/jasmine-runner/static-1.6122",
      "quartz": "/quartz/static-1.6536",
      "react-dlb": "/react-dlb/static-1.68",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-transition-group": "/react-transition-group/static-2.58",
      "redux-thunk": "/redux-thunk/static-2.43",
      "sanitize": "/sanitize/static-1.4145",
      "StyleGuideUI": "/StyleGuideUI/static-3.481",
      "transmute": "/transmute/static-2.77",
      "urlinator": "/urlinator/static-1.4193",
      "usage-tracker": "/usage-tracker/static-1.7004",
      "usage-tracker-core": "/usage-tracker-core/static-1.6854",
      "usage-tracker-public": "/usage-tracker-public/static-1.6815",
      "viral-links-lib": "/viral-links-lib/static-1.6682",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5794",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4446",
      "conversations-prop-types": "/conversations-prop-types/static-1.7116",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.20027",
      "cssUtils": "/cssUtils/static-1.690",
      "enviro": "/enviro/static-4.371",
      "flux-actions": "/flux-actions/static-1.294",
      "foundations-components": "/foundations-components/static-1.7230",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.5872",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3825",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.9296",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.334",
      "raven": "/raven/static-3.5564",
      "react": "/react/static-7.174",
      "react-aria": "/react-aria/static-1.59",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.65",
      "react-rhumb": "/react-rhumb/static-1.16294",
      "react-utils": "/react-utils/static-2.5056",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize-text": "/sanitize-text/static-1.7809",
      "signup-constants": "/signup-constants/static-1.18114",
      "styled-components": "/styled-components/static-2.83",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5418",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5605",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5234",
      "raven-hubspot": "/raven-hubspot/static-1.5871",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3104",
      "moment": "/moment/static-3.26",
      "quartz-config": "/quartz-config/static-1.314",
      "quartz-core": "/quartz-core/static-1.5755",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4499",
      "foundations-theming": "/foundations-theming/static-1.4070",
      "UIComponents": "/UIComponents/static-3.8034",
      "cv-backend-services": "/cv-backend-services/static-1.1432",
      "immutable-less": "/immutable-less/static-1.4319",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6921",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.31985",
      "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.2089",
      "customer-data-objects": "/customer-data-objects/static-1.7279",
      "data-fetching-client": "/data-fetching-client/static-1.9343",
      "icons": "/icons/static-2.607",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-router-dom": "/react-router-dom/static-5.26",
      "rpc-client-utils": "/rpc-client-utils/static-1.4272",
      "tanstack-virtual": "/tanstack-virtual/static-1.23",
      "ui-images": "/ui-images/static-2.1050",
      "HeadJS": "/HeadJS/static-2.685",
      "framer-motion": "/framer-motion/static-1.62",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2763",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.145",
      "i18n-data": "/i18n-data/static-1.214",
      "moment-timezone": "/moment-timezone/static-5.76",
      "jasmine": "/jasmine/static-4.4003",
      "history": "/history/static-4.47",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7711",
      "HubStyle": "/HubStyle/static-2.11395",
      "quartz-i18n": "/quartz-i18n/static-1.211",
      "sassPrefix": "/sassPrefix/static-1.149",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3499",
      "floating-ui": "/floating-ui/static-1.49",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1786",
      "hs-story-utils": "/hs-story-utils/static-1.9099",
      "react-virtualized": "/react-virtualized/static-2.92",
      "tanstack-table": "/tanstack-table/static-1.48",
      "trellis-assets": "/trellis-assets/static-1.921",
      "ui-fonts": "/ui-fonts/static-1.349",
      "csstype": "/csstype/static-1.50",
      "quick-fetch": "/quick-fetch/static-1.3606",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5421",
      "bender-build-tools": "/bender-build-tools/static-1.2770",
      "dispatcher": "/dispatcher/static-1.129",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.765",
      "hubspotter-http": "/hubspotter-http/static-1.4356",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.458",
      "quartz-auth": "/quartz-auth/static-1.211",
      "quartz-head": "/quartz-head/static-1.201",
      "quartz-test": "/quartz-test/static-1.211",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2553",
      "foundations-theming-base": "/foundations-theming-base/static-1.3055",
      "stylex": "/stylex/static-1.25",
      "ts-schema": "/ts-schema/static-1.3782",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
      "avatar-components": "/avatar-components/static-1.2129",
      "content-assistance-lib": "/content-assistance-lib/static-1.7256",
      "crm-component-utils": "/crm-component-utils/static-1.38123",
      "crm-display-components": "/crm-display-components/static-1.23873",
      "crm-fe-perf": "/crm-fe-perf/static-1.22546",
      "crm-links": "/crm-links/static-1.5912",
      "crm-message-bus": "/crm-message-bus/static-1.41980",
      "crm-search-service-types": "/crm-search-service-types/static-1.831",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5000",
      "customer-data-communicator": "/customer-data-communicator/static-1.44527",
      "customer-data-email": "/customer-data-email/static-1.17458",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38408",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12668",
      "customer-data-properties": "/customer-data-properties/static-1.50382",
      "customer-data-rte": "/customer-data-rte/static-1.32160",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9492",
      "draft-plugins": "/draft-plugins/static-2.21079",
      "file-manager-components": "/file-manager-components/static-1.22498",
      "FileManagerCore": "/FileManagerCore/static-1.37997",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6533",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7591",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4549",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17248",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.9764",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7759",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17370",
      "universal-associations-select": "/universal-associations-select/static-1.10626",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.7999",
      "final-form": "/final-form/static-1.63",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3555",
      "property-translator": "/property-translator/static-1.5083",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "graphql": "/graphql/static-1.75",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9137",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9135",
      "superstore": "/superstore/static-1.4437",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8390",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.27570",
      "card-properties-lib": "/card-properties-lib/static-1.43149",
      "crm-actions": "/crm-actions/static-1.5939",
      "crm-cards-data": "/crm-cards-data/static-1.1009",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.42504",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8464",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.7732",
      "customer-data-tracking": "/customer-data-tracking/static-1.6530",
      "usage-tracker-container": "/usage-tracker-container/static-1.6994",
      "framework-data-table": "/framework-data-table/static-2.11114",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8129",
      "calling-error-reporting": "/calling-error-reporting/static-1.30962",
      "calling-internal-common": "/calling-internal-common/static-1.30956",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6208",
      "crm_data": "/crm_data/static-4.90796",
      "crm_schema": "/crm_schema/static-3.90835",
      "crm-legacy-global-containers": "/crm-legacy-global-containers/static-1.23557",
      "customer-data-content": "/customer-data-content/static-1.26610",
      "draft-content-plugins": "/draft-content-plugins/static-1.27426",
      "draft-convert": "/draft-convert/static-2.31",
      "draft-email-branding-plugin": "/draft-email-branding-plugin/static-2.23421",
      "draft-extend": "/draft-extend/static-2.46",
      "draft-js": "/draft-js/static-5.37",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.23232",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23683",
      "FileManagerLib": "/FileManagerLib/static-1.38138",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17240",
      "integration-settings-components": "/integration-settings-components/static-1.14374",
      "integrations-lib": "/integrations-lib/static-1.14990",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5252",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7456",
      "nav-meta": "/nav-meta/static-1.28522",
      "onboarding-scopes": "/onboarding-scopes/static-1.6110",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.5539",
      "prosemirror": "/prosemirror/static-1.13",
      "quotes-client-types": "/quotes-client-types/static-1.36783",
      "react-colorpicker": "/react-colorpicker/static-2.9882",
      "react-dnd-compat": "/react-dnd-compat/static-1.4293",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "reference-resolvers": "/reference-resolvers/static-1.7828",
      "rich-text-lib": "/rich-text-lib/static-1.19240",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3507",
      "sequences-lib": "/sequences-lib/static-1.7485",
      "timezone-utils": "/timezone-utils/static-2.4913",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.10794",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8674",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.8677",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10014",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.9808",
      "user-context": "/user-context/static-1.4756",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.4518",
      "apollo-dlb": "/apollo-dlb/static-3.80",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4317",
      "salesImages": "/salesImages/static-1.518",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.20842",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12793",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4401",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3724",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6438",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3337",
      "lodash": "/lodash/static-4.7",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.632",
      "onboarding-tours": "/onboarding-tours/static-1.16081",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12614",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
      "ui-addon-teams": "/ui-addon-teams/static-1.21038",
      "calling-global-api": "/calling-global-api/static-1.63196",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64578",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.56872",
      "commerce-products-lib": "/commerce-products-lib/static-1.8445",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3499",
      "external-options-client-types": "/external-options-client-types/static-1.3860",
      "google-libphonenumber": "/google-libphonenumber/static-1.31",
      "hs-entities": "/hs-entities/static-1.317",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3928",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.303",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3399",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.47527",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3663",
      "property-value-citations": "/property-value-citations/static-1.996",
      "pulse": "/pulse/static-1.151",
      "smart-property-lib": "/smart-property-lib/static-1.5394",
      "tiered-pricing": "/tiered-pricing/static-1.618",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10665",
      "immerable": "/immerable/static-1.3824",
      "video-components-external": "/video-components-external/static-1.10157",
      "video-data-lib": "/video-data-lib/static-1.33815",
      "audio-components": "/audio-components/static-1.5424",
      "cropperjs": "/cropperjs/static-1.10",
      "FileManagerImages": "/FileManagerImages/static-1.35649",
      "ui-universal-auth": "/ui-universal-auth/static-1.8506",
      "video-components": "/video-components/static-1.12160",
      "video-embed": "/video-embed/static-1.34649",
      "batch-promise": "/batch-promise/static-1.1196",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3843",
      "persist-promise": "/persist-promise/static-1.3353",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.8",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.24345",
      "knowledge-content-types": "/knowledge-content-types/static-1.8266",
      "payment-link-components": "/payment-link-components/static-1.22570",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9559",
      "call-summary": "/call-summary/static-1.37887",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9283",
      "feature-store-service-types": "/feature-store-service-types/static-1.4198",
      "merchandise-lib": "/merchandise-lib/static-1.253",
      "purchase-motions-components": "/purchase-motions-components/static-1.5285",
      "self-service-api": "/self-service-api/static-1.9894",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4189",
      "chatspot-core": "/chatspot-core/static-1.19806",
      "ContentUtils": "/ContentUtils/static-1.67190",
      "copilot-toolkit": "/copilot-toolkit/static-1.10193",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6256",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.45071",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.14512",
      "customer-data-associations": "/customer-data-associations/static-1.7005",
      "deal-intel-decorators": "/deal-intel-decorators/static-1.831",
      "reporting-data": "/reporting-data/static-1.65935",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4413",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3336",
      "crm_universal": "/crm_universal/static-1.21454",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8700",
      "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20124",
      "content-embed-lib": "/content-embed-lib/static-1.7005",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.11225",
      "remote-ui": "/remote-ui/static-1.58",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5225",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.16069",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2666",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12405",
      "laboratory-lib": "/laboratory-lib/static-3.6808",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10043",
      "rxjs": "/rxjs/static-5.10",
      "messaging-types-lib": "/messaging-types-lib/static-1.44965",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "data-token-picker": "/data-token-picker/static-1.15830",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7342",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4713",
      "magpie-lib": "/magpie-lib/static-1.5242",
      "navigation-messaging": "/navigation-messaging/static-1.6212",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17483",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16601",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.147",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.7677",
      "growth-data-modal": "/growth-data-modal/static-1.4998",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2721",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1157",
      "navigation-components": "/navigation-components/static-1.16885",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.4295",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7189",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.10686",
      "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34385",
      "products-iframe-lib": "/products-iframe-lib/static-1.6998",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9519",
      "directed-graph": "/directed-graph/static-1.603",
      "event-emitter": "/event-emitter/static-1.595",
      "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5128",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9220",
      "fsm": "/fsm/static-1.3399",
      "policy-lib": "/policy-lib/static-1.6470",
      "react-tinymce": "/react-tinymce/static-1.54252",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.53378",
      "tinymce-plugins": "/tinymce-plugins/static-1.56492",
      "tinymce-themes": "/tinymce-themes/static-1.55348",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.10877",
      "content-media-compositions": "/content-media-compositions/static-2.14884",
      "idb-keyval": "/idb-keyval/static-1.37",
      "magpie-types": "/magpie-types/static-1.4702",
      "media-bridge-lib": "/media-bridge-lib/static-1.18356",
      "content-icons-ui": "/content-icons-ui/static-1.2106",
      "social-insights-client-types": "/social-insights-client-types/static-1.21040",
      "outpost": "/outpost/static-1.3884",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3351",
      "ui-addon-opt": "/ui-addon-opt/static-4.8058",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.5513",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4758",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3363",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.7211",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.18923",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.7807",
      "wootric-nps": "/wootric-nps/static-1.6605",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4205",
      "nav-client-types": "/nav-client-types/static-1.2001",
      "purchase-motions-api": "/purchase-motions-api/static-1.5288",
      "trials-service-types": "/trials-service-types/static-1.3606",
      "chatspot-client-types": "/chatspot-client-types/static-1.10310",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4471",
      "underscore": "/underscore/static-1.8",
      "simple-logging-lib": "/simple-logging-lib/static-1.2720",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36142",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38565",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.18119",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.10669",
      "crm_components": "/crm_components/static-3.90796",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.53574",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20556",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.16729",
      "project-storage": "/project-storage/static-1.4403",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.70696",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7670",
      "deal-intel-utils": "/deal-intel-utils/static-1.835",
      "reporting-client-types": "/reporting-client-types/static-1.2345",
      "react-flip-move": "/react-flip-move/static-1.63",
      "FireAlarmUi": "/FireAlarmUi/static-1.4204",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3872",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10513",
      "emoji-regex": "/emoji-regex/static-1.7",
      "association-settings-lib": "/association-settings-lib/static-1.9261",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.56779",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.11666",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.11594",
      "feedback-loader": "/feedback-loader/static-1.28624",
      "html-to-image": "/html-to-image/static-1.47",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.6721",
      "property-management-iframe": "/property-management-iframe/static-1.11800",
      "property-usages-lib": "/property-usages-lib/static-1.5053",
      "reactflow": "/reactflow/static-1.57",
      "simple-data-table": "/simple-data-table/static-1.1829",
      "used-in-list-lib": "/used-in-list-lib/static-1.6576",
      "visual-association": "/visual-association/static-1.5505",
      "highcharts": "/highcharts/static-8.97",
      "reporting-visualizations": "/reporting-visualizations/static-1.58012",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3622",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2430",
      "ContentData": "/ContentData/static-1.67265",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.645",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1737",
      "reactive-lib": "/reactive-lib/static-1.395",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.176",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.6498",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3678",
      "ui-tool-access": "/ui-tool-access/static-1.9804",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34610",
      "sales-views-client-types": "/sales-views-client-types/static-1.3961",
      "trellis-story-utils": "/trellis-story-utils/static-1.4193",
      "storybook-react": "/storybook-react/static-1.26",
      "hub-http-contrib": "/hub-http-contrib/static-1.2717",
      "interframe": "/interframe/static-3.4457",
      "tinymce-data": "/tinymce-data/static-1.39463",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4883",
      "codemirror": "/codemirror/static-5.88",
      "layout-dnd-components": "/layout-dnd-components/static-1.11803",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.10778",
      "react-codemirror": "/react-codemirror/static-1.10271",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13328",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8779",
      "hls.js": "/hls.js/static-1.32",
      "js-cookie": "/js-cookie/static-1.18",
      "ai-rendering-library": "/ai-rendering-library/static-1.8882",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7137",
      "chirp-fetch": "/chirp-fetch/static-1.1551",
      "copilot-plugins": "/copilot-plugins/static-1.10166",
      "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2887",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17545",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36142",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9480",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4690",
      "utility-belt": "/utility-belt/static-1.2211",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.21492",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.79414",
      "zustand": "/zustand/static-1.51",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6499",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.53590",
      "commerce-products-api": "/commerce-products-api/static-1.1754",
      "SafeStorage": "/SafeStorage/static-1.4069",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.55648",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.101371",
      "reporting-ui-components": "/reporting-ui-components/static-2.63208",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14397",
      "association-translator": "/association-translator/static-1.2862",
      "crm-settings-header-lib": "/crm-settings-header-lib/static-1.7970",
      "settings-ui-nav": "/settings-ui-nav/static-2.9814",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.19798",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.1576",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5538",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.3923",
      "property-management-common": "/property-management-common/static-1.4087",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.14606",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.11606",
      "ExportDialog": "/ExportDialog/static-6.10055",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33061",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "layout-data-lib": "/layout-data-lib/static-1.9103",
      "browser-eslint": "/browser-eslint/static-2.57",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.13137",
      "highlight.js": "/highlight.js/static-1.72",
      "reporting-action-components": "/reporting-action-components/static-1.40349",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9210",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5173",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.13876",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4758",
      "qrcode-generator": "/qrcode-generator/static-1.62",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.53",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17121",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.6911",
      "products-ui-components": "/products-ui-components/static-1.38964",
      "totals-ui-components": "/totals-ui-components/static-1.22645",
      "reporting-plugins": "/reporting-plugins/static-1.9800",
      "reporting-reports": "/reporting-reports/static-1.65614",
      "reporting-snowflake": "/reporting-snowflake/static-1.54554",
      "edison-service-client-types": "/edison-service-client-types/static-1.55",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.14605",
      "simple-menus-lib": "/simple-menus-lib/static-1.16122",
      "academy-common-lib": "/academy-common-lib/static-1.12597",
      "dashboard-lib": "/dashboard-lib/static-1.80100",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8355",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10095",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.15994",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.18587",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7646",
      "stripe-connect-js": "/stripe-connect-js/static-1.61",
      "commerce-permissions": "/commerce-permissions/static-1.416",
      "property-description-translator": "/property-description-translator/static-1.3529",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3519",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.7892",
      "academy-service-client": "/academy-service-client/static-1.3321",
      "redux-actions": "/redux-actions/static-3.7",
      "apps-service-types": "/apps-service-types/static-1.3541",
      "oauth-service-types": "/oauth-service-types/static-1.3910",
      "react-window": "/react-window/static-1.13"
    },
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};